const isChildCategory = (parent: string, child: string) => {
  if (parent === child) {
    return false
  }
  const parentArray = parent.split('/')
  const childArray = child.split('/')
  return parentArray.every((element, index) => element === childArray[index])
}

export default isChildCategory
